/**
 * Mount all canvases with the class "rt-animation-canvas" as RTAnimation
 * instances.
 */
export default async function mountCanvases(): Promise<void> {
	const RTAnimation = (await import("./Animation.js")).default;
	const canvases =
		document.querySelectorAll<HTMLCanvasElement>("[data-animation]");
	canvases.forEach((elem) => {
		const animationName = elem.getAttribute("data-animation");
		const assetFolder = elem.getAttribute("data-asset-folder");
		const rawOptions = elem.getAttribute("data-options");
		const options = !rawOptions || JSON.parse(rawOptions);

		if (!animationName) {
			throw new Error("Missing animation name");
		}
		new RTAnimation(elem, animationName, assetFolder, options);
	});
}
